<template>
  <div class="list-content">
    <!-- 我的执业 -->
    <div class="left">
      <!--  -->
      <ractice
        @scrollTask="scrollTask"
        @servicesProductList="servicesProductList"
        @divPracticeInformation="divPracticeInformation"
        :userData="userData"
        @goRealName="goRealName"
        :seniorityList="seniorityList"
        @ediResume="ediResume"
        v-if="serviceType == 1"
      />
      <!-- 专业服务列表 -->
      <Management
        @deleteData="deleteData"
        @add="add"
        @changeStatus="changeStatus"
        @goServiceItemsPage="goServiceItemsPage"
        @goDetails="goDetails"
        @scrollTask="scrollTask"
        @backs="serviceType = 1"
        :dataList="dataList"
        v-if="serviceType == 2"
      />
      <!-- 新增专业服务 -->
      <addPage
        :active="active"
        @goFlowPath="goFlowPath"
        @uploads="$refs.files.click()"
        @back="
          serviceType = 2
          servicesProductList(tarid)
        "
        ref="addpage"
        @adds="dialogVisible = true"
        :ser_list="ser_list"
        @delServices="delServices"
        @onSubmit="onSubmit"
        :formLabelAlign="formLabelAlign"
        :fileList="fileList"
        v-if="serviceType == 3"
      />
      <!-- 详情 -->
      <Details
        @backs="serviceType = 1"
        :optId="optId"
        v-if="serviceType == 4"
        @getNewApplicantList="getNewApplicantList"
        @userPracticing="userPracticing"
      />
    </div>

    <!-- 右边执业资格 -->
    <div class="right">
      <div class="header">
        <div class="title">可申请执业资格</div>
        <div class="more">
          没有合适我的执业类型
          <span style="color: #4587ff" @click="shenginVisible = true"
            >申请新执业类型</span
          >
        </div>
      </div>
      <div class="top">
        <div
          class="item_apply_box"
          style="border-bottom: 1px #ededed solid; padding: 20px 0"
          v-for="(el, i) in newApplyList"
          :key="i"
          @click="goApplyDetails(el)"
        >
          <div class="">
            <div class="practice_name_box">
              <span>{{ i + 1 }}</span
              >.
              <div class="">{{ el.typeName }}</div>
              <div class="time_box" v-if="el.submitTime">
                {{ el.submitTime }}
              </div>
            </div>
          </div>
          <div class="apply_label examine_color" v-if="el.status === 3">
            <span style="font-weight: 600; margin-right: 10px">·</span>
            已通过
          </div>
          <div class="apply_label no_rediv" v-else-if="el.status === 2">
            <span style="font-weight: 600; margin-right: 10px">·</span>
            未通过
          </div>
          <div class="apply_label pass_color" v-else-if="el.status === 1">
            <span style="font-weight: 600; margin-right: 10px">·</span>
            审核中
          </div>
          <div class="apply_label pass_color" v-else>
            <span style="font-weight: 600; margin-right: 10px">·</span>
            未申请
          </div>
        </div>
        <div class="empty" v-show="newApplyList.length == 0">
          {{ newApplyList }}
          <img :src="require('assets/images/kong.png')" alt="" />
          <div>暂无执业</div>
        </div>
      </div>
      <div class="header">
        <div class="title">执业审核列表</div>
      </div>
      <div class="top bottom">
        <div v-for="(el, i) in reviewList" :key="i" class="review_item">
          <div class="">
            <div class="">{{ el.name }}</div>
            <div class="review_time">{{ el.createTime }}</div>
          </div>
          <div class="label_box examine_color" v-if="el.status === 0">
            待审核
          </div>
          <div class="label_box pass_color" v-else-if="el.status === 1">
            审核通过
          </div>
          <div class="label_box no_review" v-else-if="el.status === 2">
            审核不通过
          </div>
        </div>
        <div class="empty" v-show="reviewList.length == 0">
          <img :src="require('assets/images/kong.png')" alt="" />
          <div>暂无待审核执业</div>
        </div>
      </div>
    </div>
    <input
      type="file"
      style="display: none"
      @change="doRealUpload"
      ref="files"
    />
    <!-- 新增服务项目 -->
    <el-dialog
      title="添加服务项目名称"
      :visible.sync="dialogVisible"
      width="30%"
    >
      <div>
        <el-input
          type="textarea"
          :rows="10"
          placeholder="请输入内容"
          v-model="textarea"
        >
        </el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="
            dialogVisible = false
            textarea = ''
          "
          >取 消</el-button
        >
        <el-button type="primary" @click="confime">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 实名认证弹框 -->
    <el-dialog title="实名认证" :visible.sync="realVisible" width="30%">
      <div>
        <el-form label-width="80px" :model="form">
          <el-form-item label="真实姓名">
            <el-input
              :disabled="isView"
              placeholder="请输入真实姓名"
              v-model="form.realname"
            ></el-input>
          </el-form-item>
          <el-form-item label="身份证号">
            <el-input
              :disabled="isView"
              placeholder="请输入身份证号"
              v-model="form.reccode"
            ></el-input>
          </el-form-item>
        </el-form>
        <!-- <div class="img_box">
          <div class="title">上传身份证照片</div>
          <div
            class="upload_box"
            :style="{ alignItems: front_img ? 'center' : '' }"
            @click="uploadImg(0)"
          >
            <div
              class="del_img"
              v-if="front_img"
              @click.stop="deleteIDCard(true)"
            >
              <i class="el-icon-circle-close"></i>
            </div>
            <img
              v-if="front_img"
              style="margin-top: 0; width: 80%; height: 80%"
              :src="front_img"
              mode="aspectFill"
            />
            <img
              v-else
              :src="imgUrl + 'realNameVerification_card_front.png'"
              mode="aspectFill"
            />
            <div v-if="!front_img" class="btn">上传/拍摄正面</div>
          </div>
          <div
            class="upload_box"
            :style="{ alignItems: back_img ? 'center' : '' }"
            @click="uploadImg(1)"
          >
            <div
              class="del_img"
              v-if="back_img"
              @click.stop="deleteIDCard(false)"
            >
              <i class="el-icon-circle-close"></i>
            </div>
            <img
              v-if="back_img"
              style="margin-top: 0; width: 80%; height: 80%"
              :src="back_img"
              mode="aspectFill"
            />
            <img
              v-else
              :src="imgUrl + 'realNameVerification_card_back.png'"
              mode="aspectFill"
            />
            <div v-if="!back_img" class="btn">上传/拍摄背面</div>
          </div>
        </div> -->
      </div>
      <span slot="footer" class="dialog-footer" v-if="!isView">
        <el-button
          @click="
            realVisible = false
            front_img = ''
            back_img = ''
            form.realname = ''
            form.reccode = ''
          "
          >取 消</el-button
        >
        <el-button type="primary" @click="realfime">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 执业类型申请弹框 -->
    <el-dialog title="新增执业类型" :visible.sync="shenginVisible" width="30%">
      <div>
        <el-form label-width="80px" :model="form">
          <el-form-item label="执业名称">
            <el-input
              placeholder="请输入执业名称"
              v-model="shenname"
            ></el-input>
          </el-form-item>
          <el-form-item label="主要依据">
            <el-input
              typer
              type="textarea"
              placeholder="请输入主要依据"
              v-model="shencode"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="
            shenginVisible = false
            shenname = ''
            shencode = ''
          "
          >取 消</el-button
        >
        <el-button type="primary" @click="submitType">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 个人简历 -->
    <el-dialog title="个人简历" :visible.sync="oneVisible" width="30%">
      <div>
        <div style="margin-bottom: 20px; line-height: 20px">
          请从个人基本信息（姓名、性别、民族、出生年月、籍贯等方面填写）、学习及工作经历、专业特长、现任职务等方面，客观简要表述。
        </div>
        <el-input
          type="textarea"
          :rows="10"
          placeholder="请输入内容"
          v-model="onetarea"
        >
        </el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="
            oneVisible = false
            onetarea = ''
          "
          >取 消</el-button
        >
        <el-button type="primary" @click="onefime">提交</el-button>
      </span>
    </el-dialog>
    <!-- 上传身份证正反面 -->
    <input
      type="file"
      style="display: none"
      @change="reccodeUpload"
      ref="file"
    />
  </div>
</template>

<script>
import {
  getNewApplicantList,
  userInfo,
  userPracticingQualification,
  servicesProductList,
  addServicesProduct,
  listOfServiceItems,
  deleteServicesProducts,
  addListOfServiceItems,
  modifyServices,
  deleteServices,
  getUserAuthenticationInfo,
  ossUpload,
  identifyCardInfo,
  deleteIDCard,
  addRealname,
  modifyResume,
  PracticeReviewList,
  addPracticeApply,
} from 'api/professionServer'
import ractice from './components/ractice/ractice.vue'
import Management from './components/Management/Management.vue'
import addPage from './components/addPage/addPage.vue'
import Details from './components/Details/Details.vue'
import qs from 'qs'
export default {
  props: ['taskList', 'practiceList'],
  created() {
    this.getNewApplicantList()
    this.userInfo()
    this.userPracticing()
    this.getUserAuthenticationInfo()
    this.PracticeReviewList()
  },
  components: {
    ractice,
    Management,
    addPage,
    Details,
  },
  data() {
    return {
      optId: '',
      // 1为 我的执业 2为专业服务列表 3为新增服务项目 4 为详情
      serviceType: 1,
      // 新增执业资格弹框
      shenginVisible: false,
      // 执业名称
      shenname: '',
      // 执业主要依据
      shencode: '',
      // 待审核执业
      reviewList: [],
      // 个人简历
      onetarea: '',
      // 个人简历弹框
      oneVisible: false,
      isView: false,
      // 实名认证
      form: {
        realname: '',
        reccode: '',
      },
      userData: null, // 用户信息
      frontType: 0,
      front_img: '',
      back_img: '',
      // 实名认证弹框
      realVisible: false,
      textarea: '',
      dialogVisible: false,
      ser_list: [],
      fileList: [], //上传数组
      formLabelAlign: {
        requirements: '', //相关要求
        name: '', //服务名称
        contact: '', //联系方式

        brief: '', //介绍
      },
      active: 1,
      dataList: [], // 获取专业服务列表
      imgUrl:
        'https://payment-writemall-com.oss-cn-shenzhen.aliyuncs.com/miniapps/wqzk/',
      newApplyList: [],
      seniorityList: [], // 执业资格列表
      imgList: [],
      tarid: '',
      tarids: '',
    }
  },
  methods: {
    // 去 申请资格
    goApplyDetails(el) {
      if (el.status == 1) return
      if (this.userData.authenticationStatus !== 1) {
        this.$confirm('需要实名认证之后才能进行申请', '提示', {
          confirmButtonText: '去实名',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            this.goRealName()
          })
          .catch(() => {})
        return
      }
      if (!this.userData.resume) {
        this.$message.error('请先添加个人简历后再进行申请')

        return
      }
      this.optId = el.typeId
      this.serviceType = 4
    },
    divPracticeInformation(id) {
      this.optId = id
      this.serviceType = 4
    },
    // 新增执业类型
    async submitType() {
      if (!this.shenname) {
        this.$message.error('执业名称不能为空')

        return
      }
      if (!this.shencode) {
        this.$message.error('主要依据不能为空')

        return
      }
      let opt = {
        name: this.shenname,
        content: this.shencode,
      }
      let res = await addPracticeApply(opt)
      if (res.code !== 200) return
      this.PracticeReviewList()
      this.$message.success('提交成功')
      this.shenginVisible = false
    },
    // 审核列表
    async PracticeReviewList() {
      let res = await PracticeReviewList()
      if (res.code !== 200) return
      this.reviewList = res.data
    },
    ediResume(v) {
      this.onetarea = v
      this.oneVisible = true
    },
    // 个人简历提交
    async onefime() {
      if (!this.onetarea) {
        this.$message.error('提交简历不能为空')
        return
      }
      let opt = {
        resume: this.onetarea,
      }
      let res = await modifyResume(opt)
      if (res.code !== 200) return
      this.userInfo()
      this.onetarea = ''
    },
    // 确定实名
    async realfime() {
      if (!this.form.realname || !this.form.reccode) {
        this.$message.error('请将信息填写完成')
        return
      }
      let opt = {
        cardName: this.form.realname,
        realnameType: 1,
        idNumber: this.form.reccode,
      }
      let res = await addRealname(opt)
      if (res.code !== 200) {
        this.$message.error(res.message)

        return
      }
      this.$message.success('提交成功')

      this.realVisible = false
    },
    // 删除身份证
    async deleteIDCard(type) {
      let res = await deleteIDCard(type)
      if (res.code !== 200) return
      if (type) {
        this.front_img = ''
      } else {
        this.back_img = ''
      }
    },
    // 上传身份证
    async reccodeUpload(e) {
      let file = e.target.files[0]
      let form = new FormData()
      form.append('file', file)
      form.append('file_name', file.name)
      const res = await ossUpload(form)
      console.log(res)
      if (res.code == 200) {
        if (this.frontType == 0) {
          this.front_img = res.data
        } else {
          this.back_img = res.data
        }
        if (this.front_img && this.back_img) {
          this.identifyCardInfo()
        }
      }
    },
    // 识别身份证
    async identifyCardInfo() {
      let data = {
        frontImg: this.front_img,
        reverseImg: this.back_img,
      }
      this.$message.success('开始识别')
      let res = await identifyCardInfo(data)
      if (res.code !== 200) {
        this.$message.error(res.data)
        return
      }
      this.form.realname = res.data.name
      this.form.reccode = res.data.number
    },
    uploadImg(i) {
      this.frontType = i
      this.$refs.file.click()
    },
    // 获取用户信息
    async getUserAuthenticationInfo() {
      let res = await getUserAuthenticationInfo()
      if (res.code !== 200) return (this.isView = false)
      this.form.realname = res.data.cardName
      this.form.reccode = res.data.idNumber
      this.front_img = res.data.frontImg
      this.back_img = res.data.reverseImg
      if (res.data.idNumber) {
        this.isView = true
      } else {
        this.isView = false
      }

      // this.typeId = res.data.merchantInvoiceType
      // this.merchantInvoiceType = res.data.merchantInvoiceType
    },

    // 去实名认证
    goRealName(is) {
      this.realVisible = true
    },
    deleteData(item) {
      this.$confirm('是否删除该服务', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      })
        .then(async () => {
          let res = await deleteServices(
            qs.stringify({
              id: item.id,
            })
          )
          if (res.code !== 200) return
          this.servicesProductList(this.formLabelAlign.id)
        })
        .catch(() => {})
    },
    async changeStatus(item, status) {
      let res = await modifyServices({
        id: item.id,
        status,
      })
      if (res.code !== 200) return
      this.servicesProductList(this.formLabelAlign.id)
    },
    goFlowPath(v) {
      console.log(v)
      this.active = v
    },
    // 新增服务项目
    async confime() {
      if (!this.textarea) {
        this.$message.error('请输入服务名称')
        return
      }
      let opt = {
        projectName: this.textarea,
        servicesId: this.formLabelAlign.id,
      }
      let res = undefined
      // if (this.type === 1) {
      res = await addListOfServiceItems(opt)
      // } else if (this.type === 2) {
      // 	opt.id = this.xzItem.id;
      // 	res = await addListOfServiceItems(JSON.stringify(opt));
      // }
      if (res.code !== 200) return
      this.dialogVisible = false
      this.textarea = ''
      this.listOfServiceItems(this.formLabelAlign.id)
      // if (this.type === 1) {
      this.$confirm(
        '服务信息添加成功，是否现在为其配置具体流程节点? 您也可以稍后在服务项目的“流程节点配置”中去添加。',
        '提示',
        {
          confirmButtonText: '现在配置',
          cancelButtonText: '稍后配置',
        }
      )
        .then(() => {
          this.active = 3
          this.$refs.addpage.getProjectProcess()
        })
        .catch(() => {})
      // }
    },
    delServices(item) {
      this.$confirm('是否删除该服务项', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          let res = await deleteServicesProducts(
            qs.stringify({
              id: item.id,
            })
          )
          if (res.code !== 200) return
          this.listOfServiceItems(this.formLabelAlign.id)
        })
        .catch(() => {})
    },
    // 服务项目列表
    async listOfServiceItems(id) {
      let res = await listOfServiceItems({
        servicesId: id,
      })
      if (res.code !== 200) return
      this.ser_list = res.data
    },
    // 上传图片
    async doRealUpload(e) {
      let file = e.target.files[0]
      console.log(file)
      this.fileList.push(file.name)
      console.log(this.fileList)
      let form = new FormData()
      form.append('file', file)
      const res = await ossUpload(form)
      if (res.code === 200) {
        this.imgList.push({
          path: res.data,
          name: file.name,
        })
      } else {
        this.$message({
          type: 'error',
          message: res.message,
        })
      }

      // console.log(res);
    },
    async goDetails(v) {
      this.active = 1
      this.serviceType = 3
      this.formLabelAlign = {
        requirements: v.requirements, //相关要求
        name: v.name, //服务名称
        contact: v.contact, //联系方式
        id: v.id,
        brief: v.brief, //介绍
      }

      //  let res = await addServicesProduct({practiceTypeId: v.id})
    },
    // 提交
    async onSubmit() {
      if (!this.formLabelAlign.contact)
        return this.$message.error('请输入联系方式')
      let opt = {
        ...this.formLabelAlign,
        fileJson: JSON.stringify(this.imgList),
      }
      let res = await addServicesProduct(opt)
      if (res.code !== 200) return this.$message.error(res.data)
      this.$confirm(
        '专业服务基本信息添加成功，是否现在为其配置具体服务项目?您也可以稍后在专业服务的“服务项目管理”中去添加。',
        '提示',
        {
          confirmButtonText: '现在配置',
          cancelButtonText: '稍后配置',
        }
      )
        .then(() => {
          this.active = 2
          this.listOfServiceItems(this.formLabelAlign.id)
        })
        .catch(() => {
          this.serviceType = 2
        })
    },
    async submitData() {
      let res = await addServicesProduct({
        practiceTypeId: this.formLabelAlign.id,
      })
      if (res.code !== 200) return
      this.formLabelAlign.id = res.data + ''
    },
    // 新增专业服务
    add() {
      this.active = 1
      this.serviceType = 3
      this.submitData()
    },
    // 点击服务项目配置
    goServiceItemsPage(v) {
      this.active = 2
      this.serviceType = 3
      this.tarids = v.id
      this.formLabelAlign.id = v.id
      this.listOfServiceItems(v.id)
    },

    //servicesProductList(this.tarid)
    async servicesProductList(id) {
      console.log(id)
      this.tarid = id
      let res = await servicesProductList(id)
      if (res.code !== 200) return
      this.dataList = res.data
      this.serviceType = 2
    },
    // 获取执业资格
    async userPracticing() {
      let res = await userPracticingQualification()
      if (res.code !== 200) return
      this.seniorityList = res.data
    },
    // 获取用户信息
    async userInfo() {
      let res = await userInfo()
      if (res.code !== 200) return
      let val = res.data['mobile']
      val = val.substring(0, 3) + '***' + val.substring(7)
      console.log(res.data)
      this.$store.commit('SET_USER_INFO', {
        userInfo: res.data,
      })
      localStorage.setItem('wqUserInfo', JSON.stringify(res.data))
      this.userData = res.data
    },
    scrollPractice(e) {
      let scrollTop = e.target.scrollTop //滑入屏幕滚动条滚动时，距离顶部的距离
      let windowHeitht = e.target.clientHeight //能看到的页面的高度
      let scrollHeight = e.target.scrollHeight //监控的整个div的高度（包括现在看到的和上下隐藏起来看不到的）
      let total = scrollTop + windowHeitht
      this.$parent.loddingVisible = true
      if (total == scrollHeight) {
        this.$parent.practiceQuery.page++
        // this.$parent.getPracticeList()
      }
    },
    scrollTask(e) {
      let scrollTop = e.target.scrollTop //滑入屏幕滚动条滚动时，距离顶部的距离
      let windowHeitht = e.target.clientHeight //能看到的页面的高度
      let scrollHeight = e.target.scrollHeight //监控的整个div的高度（包括现在看到的和上下隐藏起来看不到的）
      let total = scrollTop + windowHeitht
      this.$parent.loddingVisible = true
      if (total == scrollHeight) {
        this.$parent.taskQuery.page++
        // this.$parent.getTaskList()
      }
    },

    formatString(str) {
      if (str.length >= 35) {
        return str.substring(0, 36) + '......'
      } else {
        return str
      }
    },
    // 获取现有执业资格
    getNewApplicantList() {
      getNewApplicantList().then((res) => {
        this.newApplyList = res.data
        this.newApplyList = this.newApplyList.filter((el) => {
          return el.status !== 3
        })
        console.log(this.newApplyList)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.list-content {
  width: 1130px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin: 20px auto;
  > .left {
    width: 707px;
    height: 700px;
    background: #fff;
    padding: 15px 20px;
    box-sizing: border-box;
    border-radius: 10px;
  }
  > .right {
    width: 404px;
    height: 700px;
    background: #fff;
    padding: 15px 20px;
    box-sizing: border-box;
    border-radius: 10px;
    .top {
      height: 400px;
      overflow-y: auto;
    }
    .bottom {
      height: 200px;
      overflow-y: auto;
      .review_item {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px 5px;
        box-sizing: border-box;
        border-bottom: #ededed 1px solid;
        .label_box {
          padding: 7rpx 12rpx;
          border-radius: 5rpx;
          font-size: 24rpx;
          display: flex;
        }

        .pass_color {
          background: #f4f7ff;
          color: #326afb;
        }

        .no_review {
          color: #f84140;
          background: #ffefef;
        }

        .examine_color {
          color: #00be59;
          background: #e7f9f0;
        }

        .review_time {
          font-size: 10px;
          color: #a9a9a9;
          margin-top: 10px;
        }
      }
    }
    .header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 30px;
      .title {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 600;
        color: #333333;
      }
      .more {
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #999999;
        cursor: pointer;
      }
    }

    .empty {
      text-align: center;
      margin: 25% 0;
      img {
        width: 150px;
        height: 150px;
      }
      font-size: 14px;
      color: #999;
      text-align: center;
    }
  }
  .bot_box_big {
    width: 100%;
    min-height: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    margin-bottom: 10px;
    color: #333;
    padding-left: 38px;
    box-sizing: border-box;

    > div {
      display: flex;
      align-items: center;
    }

    .fun {
      cursor: pointer;
      display: flex;
      align-items: center;
      margin-left: 10px;
    }

    .time_box {
      font-size: 13px;
      color: #999999;
    }

    img {
      width: 16px;
      height: 16px;
      margin-right: 5px;
    }
  }
  .item_apply_box1 {
    width: 100%;
    padding: 5px 0;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    .num_label {
      display: flex;
      align-items: center;
      margin-right: 18px;

      .box {
        font-size: 15px;
        font-weight: bold;
        color: #326afb;
        width: 21px;
        height: 21px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #f2f6ff;
        border-radius: 50%;
      }
    }
  }
  .item_apply_box {
    width: 100%;
    padding: 5px 0;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;

    > div:first-child {
      display: flex;
      align-items: center;

      .name_apply {
        font-weight: 600;
        font-size: 15px;
      }

      > img {
        margin-right: 15px;
      }
    }

    .practice_name_box {
      display: flex;
      align-items: center;
      > div:first-child {
        font-weight: 600;
        font-size: 15px;
        color: #222222;
      }

      .time_box {
        font-size: 13px;
        color: #999999;
        // margin-top: 10px;
      }
      > span {
        display: block;
        font-size: 15px;
        font-weight: bold;
        color: #326afb;
        width: 21px;
        height: 21px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #f2f6ff;
        border-radius: 50%;
      }
    }
    .apply_label {
      cursor: pointer;
      padding: 4px 6px;
      border-radius: 3px;
      font-size: 14px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }

    .pass_color {
      background: #f4f7ff;
      color: #326afb;
    }

    .no_rediv {
      color: #f84140;
      background: #ffefef;
    }

    .examine_color {
      color: #00be59;
      background: #e7f9f0;
    }
  }
  .practice_name {
    > div:first-child {
      font-weight: 600;
      font-size: 15px;
      color: #222222;
    }

    .time_box {
      font-size: 13px;
      color: #999999;
      // margin-top: 10px;
    }
  }
  .practic {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
}
.service_box {
  padding: 4px 0;
  font-size: 14px;
  color: #326afb;
  text-align: right;
  font-weight: bold;
  cursor: pointer;
}
.img_box {
  margin-top: 40px;
  position: static;

  // &::before,
  // &::after {
  //   content: '';
  //   display: inline-block;
  //   width: 15px;
  //   height: 15px;
  //   border-radius: 50%;
  //   background: #326afb;
  //   position: absolute;
  //   top: 240px;
  // }

  // &::before {
  //   left: 5px;
  // }

  &::after {
    right: 5px;
  }

  .title {
    font-size: 15px;
    color: #333;
    font-weight: 600;
    margin-bottom: 17px;
  }

  .upload_box {
    position: relative;
    width: 100%;
    height: 179px;
    background: #e7efff;
    border-radius: 6px;
    margin-bottom: 15px;
    display: flex;
    justify-content: center;
    .del_img {
      position: absolute;
      top: 15px;
      right: 20px;
    }
    img {
      width: 176px;
      height: 106px;
      margin-top: 20px;
    }

    .btn {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 30px;
      line-height: 30px;
      text-align: center;
      background: #326afb;
      font-size: 15px;
      color: #fff;
      border-radius: 0 0 6px 6px;
    }
  }
}
</style>
